import {
  Image,
  ImageBackground,
  ScrollView,
  StyleSheet,
  Text,
  useWindowDimensions,
} from 'react-native';
import theme from 'theme';

import logoHeader from 'assets/LogoHeader.png';
import backgroundImage from 'assets/error-background-desktop.png';

import StoreLinks from 'components/StoreLinks';

export const DOWNLOAD_APP_PATH = 'baixar-app';

const DownloadAppScreen = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < 950;

  return (
    <ImageBackground source={backgroundImage} style={styles.background}>
      <ScrollView contentContainerStyle={styles.content}>
        <Image
          source={logoHeader}
          accessibilityLabel="Bandplay"
          resizeMode="contain"
          style={[styles.logo, isMobile && styles.mobileLogo]}
        />
        <Text accessibilityRole="header" style={[styles.title, isMobile && styles.mobileTitle]}>
          Band, filmes, séries e mais.{'\n'}Tudo de graça!
        </Text>
        <Text style={[styles.callToAction, isMobile && styles.mobileCallToAction]}>
          Baixe o app
        </Text>
        <StoreLinks />
        <Text style={[styles.availability, isMobile && styles.mobileAvailability]}>
          Disponível também na web e nas SmartTVs
        </Text>
      </ScrollView>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
  },
  content: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingVertical: 48,
  },
  logo: {
    width: 288,
    height: 63,
    marginBottom: 48,
  },
  mobileLogo: {
    width: 216,
    height: 48,
    marginBottom: 40,
  },
  title: {
    color: 'white',
    fontFamily: theme.fonts.inter.bold,
    fontSize: 36,
    lineHeight: 46,
    textAlign: 'center',
    maxWidth: 800,
  },
  mobileTitle: {
    fontSize: 28,
    lineHeight: 36,
  },
  callToAction: {
    color: 'white',
    fontFamily: theme.fonts.inter.regular,
    fontSize: 24,
    lineHeight: 32,
    textAlign: 'center',
    marginTop: 24,
    marginBottom: 24,
  },
  mobileCallToAction: {
    fontSize: 22,
    lineHeight: 30,
  },
  availability: {
    color: '#D8DEFF',
    fontFamily: theme.fonts.inter.regular,
    fontSize: 18,
    lineHeight: 28,
    textAlign: 'center',
    maxWidth: 560,
  },
  mobileAvailability: {
    fontSize: 16,
    lineHeight: 24,
  },
});

export default DownloadAppScreen;
